export default __webpack_public_path__ + "static/media/actify_logo.ab831ce0.svg";